import { RouterState } from 'connected-react-router';
import { AnyAction, Dispatch } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import {
  flowDialogReducer,
  FlowDialogState,
} from 'components/flowDialog/FlowDialogStore';
import { loginReducer, LoginState } from 'store/login';
import { dashboardReducer, DashboardState } from 'store/dashboard';
import { organizationReducer, OrganizationState } from 'store/organization';
import { departmentReducer, DepartmentState } from 'store/department';
import { notificationReducer, NotificationState } from 'store/notification';
import { sawmillReducer, SawmillState } from 'store/sawmill';
import {
  organizationListReducer,
  OrganizationListState,
} from 'store/organizations';

import { stackListReducer, StackListState } from 'store/stacks';
import { stackReducer, StackState } from 'store/stack';

export interface ApplicationState {
  router: RouterState;
  isLoggedIn: LoginState;
  flowDialog: FlowDialogState;
  dashboard: DashboardState;
  organization: OrganizationState;
  organizations: OrganizationListState;
  stack: StackState;
  stacks: StackListState;
  department: DepartmentState;
  notification: NotificationState;
  sawmills: SawmillState;
}

export const reducers = {
  isLoggedIn: loginReducer,
  flowDialog: flowDialogReducer,
  dashboard: dashboardReducer,
  organization: organizationReducer,
  organizations: organizationListReducer,
  stack: stackReducer,
  stacks: stackListReducer,
  department: departmentReducer,
  notification: notificationReducer,
  sawmills: sawmillReducer,
};

export interface AppThunkAction<TAction> {
  (dispatch: (action: TAction) => void, getState: () => ApplicationState): void;
}

// Type for Redux dispatch with thunk support
export type AppDispatch = ThunkDispatch<ApplicationState, unknown, AnyAction> &
  Dispatch<AnyAction>;
